import { useMutation, useQueryClient } from '@tanstack/react-query';
import { removeVoucher } from '../../api/cart/remove-voucher';
import syncCartCache from './sync-cart-cache';

const useRemoveVoucher = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: removeVoucher,
        onSuccess: (cart) => syncCartCache(queryClient, cart)
    });
};

export default useRemoveVoucher;
